// extracted by mini-css-extract-plugin
module.exports = {"input":"Year_input__3c8F6"};